export const StatusChip = ({ status }: { status: string | null }) => {
  let baseClasses =
    "px-3 py-1 rounded-full text-sm font-medium capitalize inline-block ";

  let colorClasses = "";

  switch (status) {
    case "Pending":
      colorClasses = "bg-yellow-100 text-yellow-800";
      break;
    case "Reviewed":
      colorClasses = "bg-blue-100 text-blue-800";
      break;
    case "Under Investigation":
      colorClasses = "bg-blue-100 text-blue-800";
      break;
    case "Draft Charge":
      colorClasses = "bg-purple-100 text-purple-800";
      break;
    case "Under Litigation":
      colorClasses = "bg-orange-100 text-orange-800";
      break;
    case "Council Decision":
      colorClasses = "bg-green-100 text-green-800";
      break;
    case "Closed":
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "terminated":
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Rejected":
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Revise":
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "respond_back":
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Approved":
      colorClasses = "bg-green-500 text-white";
      break;
    case "Approve":
      colorClasses = "bg-green-500 text-white";
      break;
    case "approved":
      colorClasses = "bg-green-500 text-white";
      break;
    case "Confirmed":
      colorClasses = "bg-green-500 text-white";
      break;
    default:
      colorClasses = "bg-gray-100 text-gray-800";
  }

  return <span className={`${baseClasses} ${colorClasses}`}>{status}</span>;
};
